import axios from "axios";
import Config from "src/config";

const v1_actionMessengerEnviarTeste = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/messenger/templates/enviar-teste`,
        data
    });
};

export default v1_actionMessengerEnviarTeste;
